var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import styles from './tag.styles';
let PTag = class PTag extends LitElement {
    static { this.styles = styles; }
    /**
    * Render component
    * @returns {TemplateResult} Template
    */
    render() {
        return html ` <div class="tag"> <slot></slot> </div> `;
    }
};
__decorate([
    property({ type: String, reflect: true })
], PTag.prototype, "size", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], PTag.prototype, "dark", void 0);
PTag = __decorate([
    customElement('p-tag')
    /**
    * PTag component
    *
    * @class PTag
    * @typedef {PTag}
    * @extends {LitElement}
    */
], PTag);
export { PTag };
